export const MATURITY_LABEL_MAP: Record<string, string> = {
  bronze: 'Bronze',
  silver: 'Silver',
  gold: 'Gold',
};

export const formatDagMaturity = (maturity?: string) => {
  if (!maturity) {
    return '-';
  }

  return MATURITY_LABEL_MAP[maturity.toLowerCase()] ?? maturity;
};
